import { IUserStatus, IUserStatusRaw } from 'models/user.model'

import { LoginMethod } from 'root-constants/common'

export const getUserStatusFromRawUserStatus = (
  userStatusRaw: IUserStatusRaw,
): IUserStatus => ({
  countryCode: userStatusRaw.country_code,
  city: userStatusRaw.city,
  state: userStatusRaw.state,
  isOnboardingSkipped: userStatusRaw.onboarding.is_skipped,
  onboarding: userStatusRaw.onboarding.quiz,
  config: {
    paymentCurrency: userStatusRaw.config?.payment_currency || '',
    paymentMethod: userStatusRaw.config?.payment_method || '',
    isDiscountApplied: userStatusRaw.config?.discount_applied || false,
    subscriptionPrice: userStatusRaw.config?.subscription_price || 0,
    subscriptionDuration: userStatusRaw.config?.subscription_duration || '',
    priceId: userStatusRaw.config?.price_id || '',
    trialPeriod: userStatusRaw.config?.trial_period || 0,
    trialPrice: userStatusRaw.config?.trial_price || 0,
    isPrimerPayment: userStatusRaw.config?.is_primer_payment || false,
    utmTags: userStatusRaw.config?.utm_tags,
    cookieConsent: userStatusRaw.config?.cookie_consent,
    paymentId: userStatusRaw.config?.payment_id,
    paymentSystem: userStatusRaw.config?.payment_system,
    targetUuid: userStatusRaw.config?.target_uuid,
    processorName: userStatusRaw.config?.processor_name,
  },
  email: {
    hasEmail: userStatusRaw.email.has_email,
    onboardingEmail: userStatusRaw.email.onboarding_email,
  },
  hasSubscription: userStatusRaw.subscription.has_subscription,
  account: {
    hasAccount: userStatusRaw.account.has_account,
    loginMethod: LoginMethod.EMAIL,
    email: userStatusRaw.account.identifier,
  },
  upsell: {
    isUpsellPurchased: userStatusRaw.upsell.is_upsell_purchased,
    isUpsellAvailable: userStatusRaw.upsell.is_upsell_available,
    isUpsellTried: userStatusRaw.upsell.is_upsell_tried,
  },
  upgrade: {
    isUpgradePassed: userStatusRaw.upgrade.is_upgrade_passed,
    isUpgradeAvailable: userStatusRaw.upgrade.is_upgrade_available,
  },
})
